module.exports = __webpack_public_path__ + "static/paths-f89d0d55d0a792b6ea89b8c107b0cb22.png";